import { useSelectorMemo } from 'utils/utils';

const useCurrentLayout = () => useSelectorMemo(({ scene: { config: { currentLayout, layoutId } } }) => [currentLayout, { id: layoutId, layout: currentLayout }]);

export default useCurrentLayout;
